module.exports = __webpack_public_path__ + "static/img/bg_01.43153ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/relay-event/bg_01.jpg
// module id = tQzf
// module chunks = 0